import React from 'react';
import { useFormStore } from 'simple-creator/stores/formStore';
import { useFormContext } from 'simple-creator/contexts/FormContext';
import { MediaForm, type MediaItem } from 'react-ui';

export const MediaStep: React.FC = () => {
  const { formData, updateField } = useFormStore();
  const { handleNextStep } = useFormContext();
  const images = formData.images ?? [];
  const youtubeLinks = formData.youtubeLinks ?? [];

  return (
    <div className="space-y-6">
      {/* Header with skip button */}
      <div className="text-center mb-6">
        <h3 className="text-2xl font-bold text-gray-900 mb-2">
          Add Images & Videos
        </h3>
        <p className="text-gray-600 mb-4">
          Photos and videos make your event more appealing and help people visualize the experience
        </p>
        <button
          type="button"
          onClick={handleNextStep}
          className="px-8 py-3 text-balloon border-2 border-balloon hover:bg-balloon hover:text-white rounded-full font-medium transition-colors text-base"
        >
          Skip for now →
        </button>
      </div>

      <MediaForm
        images={images}
        youtubeLinks={youtubeLinks}
        onImagesChange={(imgs: MediaItem[]) => updateField('images', imgs)}
        onYouTubeLinksChange={(links: string[]) => updateField('youtubeLinks', links)}
        maxImages={10}
      />

      {/* SEO hint: quality/indexing is the artist's responsibility, not enforced. */}
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
        <p className="text-sm text-blue-800">
          🔍 <strong>Get found on search engines:</strong> to have your event indexed,
          make sure it has a title, a description, at least one image, and a valid future date.
        </p>
      </div>
    </div>
  );
};
